var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center overflow-x-scroll gap-3 scroll-bar-none mx-auto p-2"},_vm._l((_vm.tabs),function(tab){return _c('TabItem',{key:tab.value,attrs:{"value":tab.value,"label":tab.label,"icon":tab.icon,"isActive":tab.value === _vm.active},on:{"click":function($event){return _vm.$emit('change', tab.value)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }